const tearsheetCurrencyParams = () => {
  const c = (window.Shopify && window.Shopify.currency) || {};
  return { currency: c.active || 'USD', rate: c.rate || '1.0' };
};

const modalFocusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

let tearsheetTrigger = null;

const tearsheetModal = () => document.querySelector('[data-tearsheet-modal]');

const focusableIn = (modal) => Array.from(modal.querySelectorAll(modalFocusableSelector));

const openTearsheetModal = (trigger) => {
  const modal = tearsheetModal();
  if (!modal) return;
  const error = modal.querySelector('[data-tearsheet-error]');
  if (error) error.hidden = true;
  tearsheetTrigger = trigger;
  modal.hidden = false;
  const first = focusableIn(modal)[0];
  if (first) first.focus();
};

const closeTearsheetModal = (modal) => {
  if (!modal) return;
  modal.hidden = true;
  if (tearsheetTrigger && typeof tearsheetTrigger.focus === 'function') {
    tearsheetTrigger.focus();
  }
  tearsheetTrigger = null;
};

const trapTearsheetFocus = (event) => {
  const modal = tearsheetModal();
  if (!modal || modal.hidden) return;

  if (event.key === 'Escape') {
    event.preventDefault();
    closeTearsheetModal(modal);
    return;
  }

  if (event.key !== 'Tab') return;

  const focusable = focusableIn(modal);
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const isOutside = !modal.contains(document.activeElement);

  if (event.shiftKey && (document.activeElement === first || isOutside)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || isOutside)) {
    event.preventDefault();
    first.focus();
  }
};

document.addEventListener('keydown', trapTearsheetFocus);

document.addEventListener('click', async (event) => {
  const open = event.target.closest('[data-tearsheet-open]');
  if (open) {
    openTearsheetModal(open);
    return;
  }

  const close = event.target.closest('[data-tearsheet-close]');
  if (close) {
    closeTearsheetModal(close.closest('[data-tearsheet-modal]'));
    return;
  }

  const button = event.target.closest('[data-tearsheet-download]');
  if (!button || button.disabled) return;
  const modal = button.closest('[data-tearsheet-modal]');
  const error = modal.querySelector('[data-tearsheet-error]');
  const status = modal.querySelector('[data-tearsheet-status]');
  const url = new URL(button.dataset.tearsheetUrl, window.location.origin);
  const { currency, rate } = tearsheetCurrencyParams();
  url.searchParams.set('show_price', modal.querySelector('[name=show_price]').checked ? '1' : '0');
  url.searchParams.set('show_identity', modal.querySelector('[name=show_identity]').checked ? '1' : '0');
  url.searchParams.set('currency', currency);
  url.searchParams.set('rate', rate);
  error.hidden = true;
  status.hidden = false;
  button.disabled = true;
  button.classList.add('is-generating');
  button.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(url.toString());
    if (!response.ok) throw new Error(`tearsheet ${response.status}`);
    const href = URL.createObjectURL(await response.blob());
    const a = Object.assign(document.createElement('a'), { href, download: button.dataset.tearsheetFilename });
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
  } catch (e) {
    console.error(e);
    error.textContent = "Couldn't build the PDF. Try again.";
    error.hidden = false;
  } finally {
    button.disabled = false;
    button.classList.remove('is-generating');
    button.setAttribute('aria-busy', 'false');
    status.hidden = true;
  }
});
